import React, { useState } from 'react';
// import { useTheme } from '@mui/material/styles';
// import useMediaQuery from '@mui/material/useMediaQuery';
import Grid from '@mui/material/Grid';
// import IconButton from '@mui/material/IconButton';
// import MessageIcon from '@mui/icons-material/Message';
// import { colours } from 'utils/constants';
import SearchBar from 'components/elements/SearchBar/index';
import Logout from 'components/structure/Logout/Logout';
// import SecondaryButton from 'components/elements/Form/button/secondaryButton';
import MessageOccupant from 'components/structure/Notification/MessageOccupant';
import AlertOccupant from 'components/structure/Notification/AlertOccupant';
import Modal from '../Modal';
// import { Tooltip } from '@mui/material';

type TopBarProps = {
  isMessage: boolean;
  setGlobalFilter: any;
};

export default function TopBar({ isMessage, setGlobalFilter }: TopBarProps) {
  // const theme = useTheme();
  // const isSmallScreen = useMediaQuery(theme.breakpoints.down('md'));
  const [openMessageModal, setopenMessageModal] = useState(false);
  const [openAlertModal, setopenAlertModal] = useState(false);

  return (
    <div
      className={`flex my-10 items-center ${setGlobalFilter ? 'justify-between' : 'justify-end'}`}
    >
      {setGlobalFilter && <SearchBar setGlobalFilter={setGlobalFilter} />}
      <div className="flex items-center space-x-2 md:space-x-4 ml-2 md:ml-4">
        {isMessage ? (
          <></>
        ) : (
          // <Grid item>
          //   {isSmallScreen ? (
          //     <Tooltip title="Message Occupant">
          //       <IconButton
          //         onClick={() => setopenMessageModal(true)}
          //         size="large"
          //         sx={{
          //           backgroundColor: '#FFFFFF',
          //           height: '40px',
          //           display: 'flex',
          //           alignItems: 'center',
          //           justifyContent: 'center',
          //           borderRadius: '8px'
          //         }}
          //       >
          //         <MessageIcon
          //           sx={{
          //             color: colours.seafoam
          //           }}
          //         />
          //       </IconButton>
          //     </Tooltip>
          //   ) : (
          //     <SecondaryButton
          //       buttonLabel="Message Occupant"
          //       iconLeft={<MessageIcon sx={{ color: colours.seafoam }} />}
          //       onClick={() => setopenMessageModal(true)}
          //       variant="default"
          //       size="px-4 w-auto !bg-primary2"
          //     />
          //   )}
          // </Grid>
          <></>
          // <Grid item>
          //   {isSmallScreen ? (
          //     <Tooltip title="Alert Occupant">
          //       <IconButton
          //         onClick={() => setopenAlertModal(true)}
          //         size="large"
          //         sx={{
          //           backgroundColor: '#FFFFFF',
          //           height: '40px',
          //           display: 'flex',
          //           alignItems: 'center',
          //           justifyContent: 'center',
          //           borderRadius: '8px'
          //         }}
          //       >
          //         <MessageIcon sx={{ color: colours.seafoam }} />
          //       </IconButton>
          //     </Tooltip>
          //   ) : (
          //     <SecondaryButton
          //       buttonLabel="Alert Occupant"
          //       iconLeft={<MessageIcon sx={{ color: colours.seafoam }} />}
          //       onClick={() => setopenAlertModal(true)}
          //       variant="default"
          //       size="px-4 w-auto !bg-primary2"
          //     />
          //   )}
          // </Grid>
        )}
        <Grid item>
          <Logout />
        </Grid>
      </div>
      <Modal
        isOpen={openMessageModal}
        onRequestClose={() => setopenMessageModal(false)}
        title="Send Message to Occupants"
      >
        <MessageOccupant setShowModal={setopenMessageModal} />
      </Modal>
      <Modal
        isOpen={openAlertModal}
        onRequestClose={() => setopenAlertModal(false)}
        title="Send Alert Message to Occupants"
      >
        <AlertOccupant />
      </Modal>
    </div>
  );
}
